<script type="ts">
    import { onMount } from 'svelte';
    import type { IContactAddress } from '../models/backend';
    import { getAuthenticatedData, postAuthenticatedData } from '../services/MyNemiServices';
    import InputText from './design/InputText.svelte';
    import LoadingProgress from './design/LoadingProgress.svelte';

    let contactAddress: IContactAddress;
    let saveSuccess = false;
    let validations = {};

    onMount(() =>
    {
        getAuthenticatedData<IContactAddress>('/umbraco/api/mynemi/getcontactaddress')
            .then((response) => contactAddress = response.data);
    });

    function handleFieldValidation(event)
    {
        validations[event.detail.id] = event.detail.valid;
    }

    function handleSave()
    {
        for (const validation in validations)
        {
            if (validations[validation] === false)
            {
                return;
            }
        }

        postAuthenticatedData<IContactAddress>('/umbraco/api/mynemi/savecontactaddress', contactAddress)
            .then((response) =>
            {
                contactAddress = response.data;
                saveSuccess = true;
                setTimeout(() => saveSuccess = false, 10000);
            });
    }
</script>

<div class="row">
    <div class="col"><h4>Vos coordonnées</h4></div>
</div>

{#if !contactAddress}
    <LoadingProgress/>
{:else }
    <div class="row justify-content-center">
        <div class="col-12 col-md-6">
            <InputText text="Prénom" bind:value={contactAddress.firstName} on:validation={handleFieldValidation} type={"text"} required={true}/>
        </div>
        <div class="col-12 col-md-6">
            <InputText text="Nom" bind:value={contactAddress.lastName} on:validation={handleFieldValidation} type={"text"} required={true}/>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-12 col-md-6">
            <InputText text="Société" bind:value={contactAddress.company} on:validation={handleFieldValidation} type={"text"} required={false}/>
        </div>
        <div class="col-12 col-md-6">
            <InputText text="N° de TVA" bind:value={contactAddress.tva} on:validation={handleFieldValidation} type={"text"} required={false}/>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-12">
            <InputText text="Rue et numéro" bind:value={contactAddress.street} on:validation={handleFieldValidation} type={"text"} required={true}/>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-12 col-md-4">
            <InputText text="Code Postal" bind:value={contactAddress.zipCode} on:validation={handleFieldValidation} type={"text"} required={false}/>
        </div>
        <div class="col-12 col-md-4">
            <InputText text="Ville" bind:value={contactAddress.city} on:validation={handleFieldValidation} type={"text"} required={false}/>
        </div>
        <div class="col-12 col-md-4">
            <InputText text="Pays" bind:value={contactAddress.country} on:validation={handleFieldValidation} type={"text"} required={false}/>
        </div>
    </div>

    <div class="row justify-content-center">
        <div class="col-12 col-md-6">
            <button type="submit" class="col-12 btn btn-primary" on:click={handleSave}>Sauvegarder mes informations</button>
        </div>
    </div>

    {#if saveSuccess}
        <div class="row justify-content-center pt-2">
            <div class="col-12 alert alert-success">
                Vos informations ont bien été enregistrées.
            </div>
        </div>
    {/if}
{/if}